theme.SlideShow = (function () {
  function Slider(e) {
    let sliderWrapper = e.querySelector(".hero__slider--activation"),
      slideLoop = e.dataset.slideLoop,
      slideAutoplay = e.dataset.slideAutoplay,
      autoplayDuration = e.dataset.autoplayDuration,
      slideLoopValue = true,
      autoplay = false,
      slideNavPrev = e.querySelector(".swiper-button-prev"),
      slideNavNext = e.querySelector(".swiper-button-next"),
      sliderPagination = e.querySelector(".swiper-pagination"),
      slideShowSpace = parseInt(e.dataset.slideshow)
        ? parseInt(e.dataset.slideshow)
        : 0,
      sliderPerView = parseFloat(e.dataset.slidesperview)
        ? parseFloat(e.dataset.slidesperview)
        : 1,
      smallDesktop = parseFloat(e.dataset.samlldesktopview)
        ? parseFloat(e.dataset.samlldesktopview)
        : 1,
      tabletShow = parseFloat(e.dataset.showTablet)
        ? parseFloat(e.dataset.showTablet)
        : 1,
      mobileShow = parseFloat(e.dataset.showMobile)
        ? parseFloat(e.dataset.showMobile)
        : 1,
      centeredSlides = e.dataset.centeredSlides === "true",
      centeredSlidesMobile = e.dataset.centeredSlidesMobile !== undefined ? e.dataset.centeredSlidesMobile === "true" : centeredSlides;

    if (slideLoop == "false") {
      slideLoopValue = false;
    }
    if (slideAutoplay == "true") {
      autoplay = { delay: parseInt(autoplayDuration), disableOnInteraction: false };
    }
    
    // Parse mobile overrides where supported
    let autoplayMobile = autoplay;
    if (e.dataset.slideAutoplayMobile !== undefined) {
      if (e.dataset.slideAutoplayMobile === "true") {
        autoplayMobile = { delay: parseInt(e.dataset.autoplayDurationMobile || autoplayDuration), disableOnInteraction: false };
      } else {
        autoplayMobile = false;
      }
    }

    var swiper = new Swiper(sliderWrapper, {
      slidesPerView: mobileShow,
      autoplay: autoplayMobile,
      loop: slideLoopValue,
      centeredSlides: centeredSlidesMobile,
      clickable: true,
      speed: 1000,
      spaceBetween: slideShowSpace,
      pagination: {
        el: sliderPagination,
        clickable: true,
      },
      navigation: {
        nextEl: slideNavNext,
        prevEl: slideNavPrev,
      },
      breakpoints: {
        0: {
          slidesPerView: mobileShow,
          centeredSlides: centeredSlidesMobile,
          autoplay: autoplayMobile,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: smallDesktop,
          centeredSlides: centeredSlides,
          autoplay: autoplay,
        },
        1200: {
          slidesPerView: sliderPerView,
          centeredSlides: centeredSlides,
          autoplay: autoplay,
        },
      },
    });
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return Slider;
})();
